import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { e } from 'msw/lib/core/on-unhandled-frame-BBR-P3kV';

if (environment.production) {
    enableProdMode();
    console.log("Production mode enabled", environment.msw, environment.production);
    if (window) {
        // Suppress console logs
        //window.console.log = function () { };
        window.console.warn = function () { };
        window.console.info = function () { };
        //window.console.error = function () { };
    }
}

// Allowed users and their allowed projectKuids
const allowedAccounts: Record<string, string[]> = {
    "sales@fusionsuite.io": ["290DA94858EA40F5840184897F710001"],
    "talha.tauqeer@o3interfaces.com": ["253A46CA3B474D91A6ACA3E4A4F555BD"],
    "muhammad.taqi@o3interfaces.com": ["7DB13F85E5D644D18B97EB76C3BB0115"],
    "signoffs@o3interfaces.com": ["126FA7E1CA2C4D03AB8A308009A14633", "96AFFCB5470446E9B278995DE3E5DFC4"]
};

const item = JSON.parse(localStorage.getItem("selectedProject") || "{}")?.p_kuid;
const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}")?.email;
console.log({
    msw: environment.msw,
    currentUser,
    item,
    accounts: allowedAccounts[currentUser],
    includes: allowedAccounts[currentUser]?.includes(item)
});
async function enableMocking() {
    if (environment.msw && environment.production) {
        // if (environment.msw ) {
        const { worker } = await import('./mocks/browser');
        console.log("mock start");
        await worker.start({
            onUnhandledRequest: "bypass",
            serviceWorker: { url: "/mockServiceWorker.js" },
        });
    }

}
// async function enableMocking() {
//     if (environment.msw || (currentUser && item && allowedAccounts[currentUser]?.includes(item))) {
//         // if (environment.msw ) {
//         const { worker } = await import('./mocks/browser');
//         console.log("mock start");
//         await worker.start({
//             onUnhandledRequest: "bypass",
//             serviceWorker: { url: "/mockServiceWorker.js" },
//         });
//     }
// }

enableMocking().then(() => {
    // confirm("Mocking is enabled. Do you want to proceed with bootstrapping the Angular application?");
    platformBrowserDynamic().bootstrapModule(AppModule)
        .catch(err => console.error(err));
});


// platformBrowserDynamic()
//     .bootstrapModule(AppModule)
//     .catch((err) => console.error(err));

// enableMocking().then(() => {
//     platformBrowserDynamic().bootstrapModule(AppModule)
//         .catch(err => console.error(err));
// });
// Register Firebase Messaging Service Worker
// if ('serviceWorker' in navigator) {
//     navigator.serviceWorker
//         .register('firebase-messaging-sw.js', { scope: '/' })
//         .then(reg => {
//             console.log('✅ Firebase Messaging SW registered', reg);
//             // Ensure service worker is active
//             if (reg.active) {
//                 console.log('✅ Firebase Messaging SW is active');
//             } else if (reg.installing) {
//                 reg.installing.addEventListener('statechange', function () {
//                     if (this.state === 'activated') {
//                         console.log('✅ Firebase Messaging SW activated');
//                     }
//                 });
//             }
//         })
//         .catch(err => {
//             console.error('❌ Firebase Messaging SW registration failed', err);
//             // Retry registration after delay
//             setTimeout(() => {
//                 navigator.serviceWorker
//                     .register('firebase-messaging-sw.js', { scope: '/' })
//                     .then(reg => console.log('✅ Firebase Messaging SW registered on retry', reg))
//                     .catch(retryErr => console.error('❌ Firebase Messaging SW retry failed', retryErr));
//             }, 3000);
//         });
// }



platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));

